import React from 'react';

export type BadgeColor = 'gray' | 'green' | 'yellow' | 'red';

interface TabBadgeProps {
  label: string;
  total: number;
  unread: number;
  hasMention?: boolean;
}

function getBadgeColor(total: number, unread: number, hasMention: boolean): BadgeColor {
  if (total === 0) return 'gray';
  if (unread === 0) return 'green';
  if (hasMention) return 'red';
  return 'yellow';
}

const COLORS: Record<BadgeColor, { bg: string; text: string }> = {
  gray:   { bg: '#d0d0d0', text: '#555' },
  green:  { bg: '#107c10', text: '#fff' },
  yellow: { bg: '#d4960a', text: '#fff' },
  red:    { bg: '#c50f1f', text: '#fff' },
};

export const TabBadge: React.FC<TabBadgeProps> = ({ label, total, unread, hasMention = false }) => {
  const color = getBadgeColor(total, unread, hasMention);
  const { bg, text } = COLORS[color];
  const count = unread > 0 ? unread : total;

  return (
    <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
      {label}
      <span
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          minWidth: 18,
          height: 18,
          borderRadius: 9,
          padding: '0 5px',
          fontSize: 11,
          fontWeight: 600,
          lineHeight: 1,
          background: bg,
          color: text,
          userSelect: 'none',
        }}
        title={
          unread > 0
            ? `${unread} ungelesen${hasMention ? ', inkl. @Erwähnung' : ''}`
            : total === 0
            ? 'Keine Einträge'
            : `${total} Einträge (alle gelesen)`
        }
      >
        {count}
      </span>
    </span>
  );
};
